<div class="email-blocker-container d-flex flex-column align-items-center justify-content-end" [style.min-height]="minHeight">
  <div class="linear-gradient-bg"></div>
  <img class="shadow-logo" src="assets/images/osn-logo.svg" />
  <h2 class="title mb-2">{{ vm.title | replacePriceAndCurrency: vm.subscriptionPrice:vm.currency }}</h2>
  <p class="subtitle">{{ vm.sublineText }}</p>
  <div class="input-container">
    <osn-shared-email-collector
      [inputPlaceholder]="vm.inputLabel | translate"
      [buttonText]="vm.buttonText | translate"
      [passwordPlaceholder]="'Email_Collector_password_placeholder' | translate"
      [showAgreementTextBelowCtaButton]="true"
    ></osn-shared-email-collector>
    <div class="d-flex flex-wrap mt-3 login-text-container justify-content-center">
      <p class="login-text">{{ 'Start_Trial_Dialog_user_has_account_text' | translate }}&nbsp;</p>
      <p class="login-link" (click)="signIn()">{{ 'Start_Trial_Dialog_login_link_txt' | translate }}</p>
    </div>
  </div>
</div>
